import styles from "../styles/components/Warning.module.scss";
import warning from "../assets/images/warning.svg";
import { useTranslation } from "react-i18next";

type Props = {
    onConfirm: () => void;
    onCancel: () => void;
    isLoading?: boolean;
    title?: string;
    message?: string;
    cta?: string;
}

const Warning : React.FC<Props> = ({onConfirm, onCancel, isLoading, title, message, cta="Ja, verwijderen"}) => {
    const {t} = useTranslation()
    return (
        <div className={styles.warning}>
            <button onClick={()=>{onCancel()}} className={styles.close}><svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></button>
            <img className={styles.image} src={warning} alt="Warning"/>
            <div className={styles.body}>
                <p className={styles.title}>{title ? title : t("Bent u zeker")}</p>
                <p className={styles.description}>{message ? message : t("Indien u dit verwijderd")}</p>
                <button disabled={isLoading} onClick={()=>{onConfirm()}} className={`${styles.button}`}>{!isLoading ? t("Verwijderen") : t("Even geduld")}</button>
            </div>
        </div>
    )
}

export default Warning;